export const useToggle = (initialState = false) => {
    const value = ref(initialState);
    const toggle = () => value.value = !value.value;

    return {
        value,
        toggle
    }
}